import { render, staticRenderFns } from "./main-layout.vue?vue&type=template&id=0a9dd4ec&scoped=true"
import script from "./main-layout.vue?vue&type=script&lang=js"
export * from "./main-layout.vue?vue&type=script&lang=js"
import style0 from "./main-layout.vue?vue&type=style&index=0&id=0a9dd4ec&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9dd4ec",
  null
  
)

export default component.exports